import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import Dock from 'react-dock';
import { Close } from './shapes/hamburger';
import { granite } from './colors';

var Drawer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Drawer, _React$Component);

  function Drawer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Drawer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Drawer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "hideDrawer", function () {
      _this.props.onRequestHide && _this.props.onRequestHide();
    });

    _defineProperty(_assertThisInitialized(_this), "handleVisibleChange", function () {
      if (_this.props.closeOnClickOutside) {
        _this.hideDrawer();
      }
    });

    return _this;
  }

  _createClass(Drawer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!this.props.show) {
        document.body.className = document.body.className.replace(/ ?drawer-open/, '');
      } else if (this.props.show && !prevProps.show) {
        document.body.className += document.body.className.length ? ' drawer-open' : 'drawer-open';
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // clean up any open drawer classes from the body before unmounting the component
      document.body.className = document.body.className.replace(/ ?drawer-open/, '');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          show = _this$props.show,
          position = _this$props.position,
          autoResize = _this$props.autoResize,
          size = _this$props.size,
          header = _this$props.header,
          footer = _this$props.footer,
          children = _this$props.children,
          headerStyle = _this$props.headerStyle,
          footerStyle = _this$props.footerStyle,
          bodyStyle = _this$props.bodyStyle,
          style = _this$props.style,
          className = _this$props.className,
          zIndex = _this$props.zIndex;
      var customHeader;

      if (header) {
        customHeader = React.isValidElement(header) ? header : React.createElement("h2", null, header);
      }

      var drawerHeader = React.createElement("div", {
        className: "drawer-header",
        style: headerStyle
      }, React.createElement("button", {
        className: "close",
        onClick: this.hideDrawer
      }, React.createElement(Close, {
        width: "18px",
        color: granite.base,
        cropped: true
      })), customHeader);
      var drawerFooter = footer && React.createElement("div", {
        className: "drawer-footer",
        style: footerStyle
      }, footer); // don't allow any other values

      var drawerPosition = position || 'right';
      var drawerNode = React.createElement(Dock, {
        fluid: autoResize,
        size: size,
        position: drawerPosition,
        isVisible: show,
        dimMode: "opaque",
        zIndex: zIndex,
        dimStyle: {
          background: 'rgba(0, 0, 0, 0.5)'
        },
        onVisibleChange: this.handleVisibleChange
      }, React.createElement("div", {
        className: "drawer-content ".concat(className || ''),
        style: style
      }, drawerHeader, React.createElement("div", {
        className: "drawer-body",
        style: bodyStyle
      }, children), drawerFooter));
      return ReactDOM.createPortal(drawerNode, document.body);
    }
  }]);

  return Drawer;
}(React.Component);

export { Drawer as default };
Drawer.propTypes = {
  show: PropTypes.bool.isRequired,
  position: PropTypes.oneOf(['left', 'right', 'top', 'bottom']),
  autoResize: PropTypes.bool,
  size: PropTypes.number,
  header: PropTypes.node,
  footer: PropTypes.node,
  children: PropTypes.node,
  closeOnClickOutside: PropTypes.bool,
  onRequestHide: PropTypes.func,
  headerStyle: StylePropType,
  footerStyle: StylePropType,
  bodyStyle: StylePropType,
  style: StylePropType,
  className: PropTypes.string,
  zIndex: PropTypes.number
};
Drawer.defaultProps = {
  position: 'right',
  autoResize: true,
  size: 0.3,
  zIndex: 1040
};